/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: "false" | "true" }} Gateway_Add_Wifi_StatusInputs */



/**
* | status | output |
* | --- | --- |
* | "false" | "Disabled (wifi off)" |
* | "true" | "Enabled (wifi on)" |
*
* @param {Gateway_Add_Wifi_StatusInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gateway_add_wifi_status = /** @type {((inputs: Gateway_Add_Wifi_StatusInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Add_Wifi_StatusInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.status === "false") return /** @type {LocalizedString} */ (`Disabled (wifi off)`);
		if (i?.status === "true") return /** @type {LocalizedString} */ (`Enabled (wifi on)`);
		return /** @type {LocalizedString} */ ("gateway_add_wifi_status");
	}
	{
		if (i?.status === "false") return /** @type {LocalizedString} */ (`Désactivé (wifi éteint)`);
		if (i?.status === "true") return /** @type {LocalizedString} */ (`Activé (wifi allumé)`);
		return /** @type {LocalizedString} */ ("gateway_add_wifi_status");
	}
});